export default function initFiltroCategoriasBlog() {
    const filtrosContainer = document.querySelector('.c-filtros');
    const linksFiltro = document.querySelectorAll('.c-filtros__item');

    linksFiltro.forEach(link => {
        link.addEventListener('click', function () {
            sessionStorage.setItem('scroll_to_grid', 'true');
        });
    });

    if (!filtrosContainer) return;

    let isDown = false;
    let startX;
    let scrollLeft;
    let moved = false;

    // --- 1. Lógica de Centralização Dinâmica ---
    const centerActiveItem = () => {
        const activeItem = filtrosContainer.querySelector('.c-filtros__item.is-active');

        if (activeItem) {
            // Calcula a posição para centralizar o item ativo
            const containerWidth = filtrosContainer.offsetWidth;
            const itemOffset = activeItem.offsetLeft;
            const itemWidth = activeItem.offsetWidth;

            const scrollPos = itemOffset - (containerWidth / 2) + (itemWidth / 2);

            filtrosContainer.scrollTo({
                left: scrollPos,
                behavior: 'smooth' // Deslize suave até o item
            });
        }
    };

    initTabDrag();

    setTimeout(centerActiveItem, 100);
}
function initTabDrag() {
    const slider = document.querySelector('.c-filtros');
    if (!slider) return;

    let isDown = false;
    let startX;
    let scrollLeft;

    slider.addEventListener('mousedown', (e) => {
        isDown = true;
        slider.classList.add('is-dragging');
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;

        e.preventDefault();
    });

    slider.addEventListener('mouseleave', () => {
        isDown = false;
        slider.classList.remove('is-dragging');
    });

    slider.addEventListener('mouseup', () => {
        isDown = false;
        slider.classList.remove('is-dragging');
    });

    slider.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - slider.offsetLeft;
        const walk = (x - startX) * 2;
        slider.scrollLeft = scrollLeft - walk;
    });
}